const photoEnhancer = {
  UnlimitedNumberOfSheets: '無制限の画像数',
  SupportAllModels: 'すべてのモデルをサポート',
  MagnificationAllX: '倍率：1x、2x、4x、8x',
  OutputImageFormatMore: '出力画像形式：JPG、PNG、TIFF',
  NoWatermark: '透かしはありません',
  CancelAtAnytime: 'いつでもキャンセルできます',
  HighPriorityProcessingSpeed: '優先度の高い処理速度',
  HitPawAIPhotoEnhancer: 'HitPaw AI Photo Enhancer',
  weekDayPrice: '¥186',
  WeekTotalPrice: '¥1,299',
  MonthDayPrice: '¥87',
  MonthTotalPrice: '¥2,599',
  YearDayPrice: '¥47',
  YearTotalPrice: '¥1,6999',
  Day: '日',
  Monthly: '月',
  Weekly: '週',
  Yearly: '年',
};

export default photoEnhancer;
